import { render, staticRenderFns } from "./EditArtworks.vue?vue&type=template&id=00bcbb47&scoped=true&"
import script from "./EditArtworks.vue?vue&type=script&lang=js&"
export * from "./EditArtworks.vue?vue&type=script&lang=js&"
import style0 from "./EditArtworks.vue?vue&type=style&index=0&id=00bcbb47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bcbb47",
  null
  
)

export default component.exports